import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rippling = defineConnector({
  identifier: "rippling",
  name: "Rippling",
  tagLine: "HR, IT, and finance platform",
  keywords: "hr hris payroll employees it device management spend",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.rippling\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Rippling App",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Rippling Developer Portal](https://developer.rippling.com/) and create a new application to get your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure your app",
      items: [
        {
          kind: "markdown",
          content:
            "Copy and paste the following Redirect URI into your app settings:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/rippling/callback",
        },
      ],
    },
    {
      title: "Enter your client credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client Secret",
          placeholder: "Paste your Client Secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content: "Add scopes in a space separated list below.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "employee:read company:read",
          required: true,
          defaultValue: "employee:read",
          helperText: "Space separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Rippling account",
      items: [
        {
          kind: "markdown",
          content:
            "Finally, authorize your Rippling account to complete the connection.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://app.rippling.com/apps/PLATFORM/oauth/authorize",
    tokenEndpoint: () => "https://api.rippling.com/platform/api/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.rippling.com/platform/api/companies/current",
  },
});
